import { Box, Grid, IconButton, Tooltip } from "@mui/material";
import AccordianContainer from "../../../../CustomComponents/AccordianContainer";
import CustomDataGrid from "../../../../CustomComponents/CustomDataGrid";
import { Visibility } from "@mui/icons-material";
import BusinessIncomeAssesRefDialog from "./BusinessIncomeAssesRefDialog";
import { useState } from "react";
import BusinessIncomeAssesLocDialog from "./BusinessIncomeAssesLocDialog";

const BusinessIncomeAssessmentDetail = ({ businessIncomeAssessment }) => {
  const [businessRefOpen, setBusinessRefOpen] = useState(false);
  const [businessLocOpen, setBusinessLocOpen] = useState(false);
  const [referenceList, setReferenceList] = useState([]);
  const [locationList, setLocationList] = useState([]);

  const queryListColumns = [
    {
      field: "businessAssessmentId",
      headerName: "Business Assessment ID",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "internalApplicationId",
      headerName: "Internal Application ID",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "assessedRole",
      headerName: "Assessed Role",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "average3MonthRevenue",
      headerName: "Average 3 Month Revenue",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "average3MonthSalary",
      headerName: "Average 3 Month Salary",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "materialCost",
      headerName: "Material Cost",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "salaryExpenses",
      headerName: "Salary Expenses",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "operatingExpenses",
      headerName: "Operating Expenses",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "rent",
      headerName: "Rent",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "conveyanceExpenses",
      headerName: "Conveyance Expenses",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "deductionExpense",
      headerName: "Deduction Expense",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "other1",
      headerName: "Other 1",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "other2",
      headerName: "Other 2",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "totalBusinessExpenses",
      headerName: "Total Business Expenses",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "netBusinessIncome",
      headerName: "Net Business Income",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "netBusinessMargin",
      headerName: "Net Business Margin",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "template",
      headerName: "Template",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "location",
      headerName: "Location",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              justifyContent: "center",
              display: "flex",
              flex: 25,
            }}
          >
            {params.row.location !== null &&
            params.row.location !== undefined &&
            params.row.location.length !== 0 ? (
              <Tooltip title="View Location">
                <IconButton
                  onClick={(e) => {
                    setLocationList(params.row.location);
                    setBusinessLocOpen(true);
                  }}
                >
                  <Visibility sx={{ color: "black" }} />
                </IconButton>
              </Tooltip>
            ) : (
              <p> No Location </p>
            )}
          </Box>
        );
      },
    },
    {
      field: "refferences",
      headerName: "References",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              justifyContent: "center",
              display: "flex",
              flex: 25,
            }}
          >
            {params.row.refferences !== null &&
            params.row.refferences !== undefined &&
            params.row.refferences.length !== 0 ? (
              <Tooltip title="View References">
                <IconButton
                  onClick={(e) => {
                    setBusinessRefOpen(true);
                    setReferenceList(params.row.refferences);
                  }}
                >
                  <Visibility sx={{ color: "black" }} />
                </IconButton>
              </Tooltip>
            ) : (
              <p> No References </p>
            )}
          </Box>
        );
      },
    },
  ];

  return (
    <>
      <AccordianContainer
        id="accord"
        title="Business Income Assessment Details"
        initialOpen={false}
      >
        <Box sx={{ marginTop: "-0.5%" }}>
          <CustomDataGrid
            noDataMessage="No Data"
            rows={
              businessIncomeAssessment !== undefined &&
              businessIncomeAssessment !== null
                ? businessIncomeAssessment.map((item, index) => ({
                    id: index + 1,
                    ...item,
                  }))
                : []
            }
            columns={queryListColumns}
            pageSize={15}
            pageSizeOptions={[10]}
            gridLazyLoad={() => {}}
            gridHeight={305}
            getRowId={(row) => row.businessAssessmentId}
            onCellKeyDown={(event, param) => {
              (param.key === "e" || param.key === "E") &&
                param.preventDefault();
            }}
          />
        </Box>
      </AccordianContainer>
      <BusinessIncomeAssesRefDialog
        businessRefOpen={businessRefOpen}
        setBusinessRefOpen={setBusinessRefOpen}
        referenceList={referenceList}
      />
      <BusinessIncomeAssesLocDialog
        businessLocOpen={businessLocOpen}
        setBusinessLocOpen={setBusinessLocOpen}
        locationList={locationList}
      />
    </>
  );
};

export default BusinessIncomeAssessmentDetail;
